import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IStatusResponse } from '@umu/umu-types';

export const deletePk = (id: string): Promise<IStatusResponse> => {
    return fetchData(API.COURSE_PK_DELETE, JSON.stringify({ id }));
};
